export const version = '0.810.0'
export const chameleonWebVersion = '10.5.1'
export const chameleonCoreVersion = '7.14.0'
